import React from "react";
import { useTranslation } from "react-i18next";

export default function VoltagesCard({ title, data, type }) {
  const { t } = useTranslation();
  // type: "phase" | "line"
  const items =
    type === "phase"
      ? [
        { key: "VL1", label: "L1-N" },
        { key: "VL2", label: "L2-N" },
        { key: "VL3", label: "L3-N" },
      ]
      : [
        { key: "VL12", label: "L1-2" },
        { key: "VL23", label: "L2-3" },
        { key: "VL31", label: "L3-1" },
      ];

  // helper: sadece sayı ise 2 basamak göster
  const formatValue = (val) => {
    if (val === null || val === undefined) return "-";
    if (isNaN(val)) return val;
    return Number(val).toFixed(2);
  };

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
        {items.map((item) => (
          <div
            key={item.key}
            className="border rounded-lg p-3 bg-gray-50 shadow-sm"
          >
            <p className="text-sm font-medium text-gray-700">{item.label}</p>
            <p className="text-xs text-green-700">
              {t('common.max')}: {formatValue(data?.[`${item.key}_MAX`])} V
            </p>
            <p className="text-xs text-red-700">
              {t('common.min')}: {formatValue(data?.[`${item.key}_MIN`])} V
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
